//------------------------------------------------------------------------------
// 地図部品 電柱属性
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import '@esri/calcite-components/dist/components/calcite-table';
import '@esri/calcite-components/dist/components/calcite-table-row';
import '@esri/calcite-components/dist/components/calcite-table-cell';
import {
  CalciteTable,
  CalciteTableRow,
  CalciteTableCell,
} from '@esri/calcite-components-react'

/**
 * 電柱属性一覧
 */
export function PoleAttributes({ children, cssStyle }) {
  return (
    <CalciteTable
      caption="電柱属性"
      scale="s"
      striped={true}
      style={cssStyle}
    >
      {children}
    </CalciteTable>
  );
}

// プロパティ
PoleAttributes.propTypes = {
  cssStyle: PropTypes.object,   // CSSスタイル
  children: PropTypes.node,     // 電柱属性要素
};

/**
 * 電柱属性要素
 */
export function PoleAttribute({ label, value }) {
  return (
    <CalciteTableRow>
      <CalciteTableCell>{label}</CalciteTableCell>
      <CalciteTableCell>{value}</CalciteTableCell>
    </CalciteTableRow>
  );
}

// プロパティ
PoleAttribute.propTypes = {
  label: PropTypes.string,    // 属性名
  value: PropTypes.string,    // 属性値
};

// デフォルトエクスポート
export default {
  PoleAttribute,
  PoleAttributes,
};
